import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { ClearLocalStorage } from "../../store/mahutiLocalStorage";
import { resetSelections } from "../../store/MahutiReducer";
import './PaymentFailed.css'
import { useEffect } from "react";
import { EVENT_IFRAME_BACK, PREFIX_PATH } from "../../utils/GlobalParams";

export default function PaymentFailed(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const store = useSelector(state => state.reducer);
    const onBackHandle = (e) => {
        dispatch(resetSelections())
        let lpPrefix = store.lpName ? '/' + store.lpName : '';
        navigate(PREFIX_PATH + lpPrefix + '/');
    }
    useEffect(()=>{
        //Add event disapcher for parent widnow back function        
        document.getElementById('payment_back').addEventListener('click', e => {
            window.parent.postMessage(
                {
                    type: 'button-click',
                    message: EVENT_IFRAME_BACK,
                },
                '*'//TODO: Change to www.mahuti.co.il
                )
            })
    },[]);
    return <div className="PaymentFailed">
                <div className="content">
                    <div className="p-3">
                        {/* <i className="icon-Success" /> */}
                    </div>
                    <h1 className="header-cover-title p-3">ארעה שגיאה , לא בוצע תשלום:(</h1>
                    <h2 className="text-mahuti p-3">אנא נסה שוב</h2>
                    <button id='payment_back' className="btn-primary" >חזור</button>

                </div>
            </div>
}